<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="entries"
      sort-by="createdAt"
      :sort-desc="true"
      class="elevation-1"
      :hide-default-footer="true"
      :disable-pagination="true"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-badge
            v-if="entries.length && type!== 'history'"
            color="primary"
            :content="entries.length"
            class="mt-2"
          >
            <v-toolbar-title>{{title}}</v-toolbar-title>
          </v-badge>
          <v-toolbar-title v-else>{{title}}</v-toolbar-title>
          <v-divider v-if="type=== 'history'" class="mx-4" inset vertical></v-divider>
          <div v-if="type=== 'history'">{{entries.length}} demandes</div>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="80%">
            <v-card>
              <v-card-title>Mise à jour d'une demande</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="8">
                      <access-control-form :initialData="editedItem" />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-select
                        label="Statut"
                        :items="editedItem.status === 'pending' ? status : status.filter(s => s.value !== 'pending')"
                        v-model="editedItem.status"
                        outlined
                        dense
                      ></v-select>
                      <v-textarea
                        v-if="editedItem.status === 'processing'"
                        v-model="editedItem.comments"
                        label="Commentaires (non visible pour les demandeurs)"
                        outlined
                        dense
                      ></v-textarea>
                      <v-textarea
                        v-if="editedItem.status === 'rejected'"
                        v-model="editedItem.deletionComments"
                        label="Raison du refus (visible pour les demandeurs)"
                        outlined
                        dense
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close" :disabled="submitting">Annuler</v-btn>
                <v-btn text @click="save" :loading="submitting">Mettre à jour</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:body="{ items }">
        <tbody class="text-left">
          <tr v-for="item in items" :key="item.name" @click="editItem(item)">
            <td>{{item.requesterEmail}}</td>
            <td>{{item.createdAt | formatDate}}</td>
            <td v-if="type=== 'history'">{{item.unity}}</td>
            <td v-if="type=== 'history'">
              <v-chip
                color="grey"
                text-color="white"
                v-if="item.status === 'pending'"
                small
              >À traiter</v-chip>
              <v-chip
                small
                color="orange"
                text-color="white"
                v-if="item.status === 'processing'"
              >En attente</v-chip>
              <v-chip
                small
                color="green"
                text-color="white"
                v-if="item.status === 'accepted'"
              >Acceptée</v-chip>
              <v-chip small color="red" text-color="white" v-if="item.status === 'rejected'">Refusée</v-chip>
              <v-chip
                small
                color="grey lighten-1"
                text-color="white"
                v-if="item.status === 'manual'"
              >Traitée manuellement</v-chip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar.visible" :bottom="true" :right="true" :color="snackbar.color">
      {{snackbar.text}}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import AccessControlForm from "@/components/AccessControlForm";
import axios from "axios";

export default {
  props: ["entries", "title", "type"],
  components: {
    AccessControlForm
  },
  mounted() {
    if (this.type === "history") {
      this.headers = [
        {
          text: "E-mail requérant",
          align: "start",
          value: "requesterEmail"
        },
        {
          text: "Date demande",
          align: "start",
          value: "createdAt"
        },
        {
          text: "Entité",
          align: "start",
          value: "unity"
        },
        {
          text: "Statut",
          align: "start",
          value: "status"
        }
      ];
    } else {
      this.headers = [
        {
          text: "E-mail requérant",
          align: "start",
          value: "requesterEmail"
        },
        {
          text: "Date demande",
          align: "start",
          value: "createdAt"
        }
      ];
    }
  },
  data: () => ({
    dialog: false,
    headers: [],
    editedIndex: -1,
    editedItem: {},
    status: [
      { text: "À traiter", value: "pending" },
      { text: "En attente de complément", value: "processing" },
      { text: "Acceptée", value: "accepted" },
      { text: "Refusée", value: "rejected" },
      { text: "Traitée manuellement", value: "manual" }
    ],
    comments: "",
    deletionComments: "",
    snackbar: {
      visible: false,
      color: "",
      text: ""
    },
    submitting: false
  }),
  filters: {
    formatDate: function(value) {
      return format(parseISO(value), "dd.MM.yyyy");
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.entries.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        this.submitting = true;
        try {
          const { data: response } = await axios({
            method: "patch",
            url: `${process.env.VUE_APP_API_URI}/${this.editedItem._id}`,
            data: { ...this.editedItem }
          });
          this.editedItem.outlookId = response.outlookId;
          Object.assign(this.entries[this.editedIndex], this.editedItem);
          this.snackbar = {
            visible: true,
            color: "success",
            text: "Demande mise à jour"
          };
          this.submitting = false;
        } catch (error) {
          this.snackbar = {
            visible: true,
            color: "error",
            text: "Erreur de mise à jour"
          };
          this.submitting = false;
        }
      }
      this.close();
    }
  }
};
</script>

<style scoped>
tr {
  cursor: pointer;
}
</style>